import React from 'react';

/**
 * Der Satz unter einem Feld, das der Redaktion gesperrt ist oder beim Speichern etwas auslöst, das der
 * Moderation gehört — Texte und Regeln in `utils/moderation.ts`.
 *
 * Zwei Tonlagen: der schlichte Hinweis (grau, wie die übrigen Feld-Hinweise der Formulare) für ein
 * gesperrtes Feld, die Warnfläche (wie die veralteten Themen im `TopicCategoryPicker`) für den Rückfall
 * auf den Entwurf — dort geht ein öffentliches Werk aus der App, das soll nicht wie eine Fußnote aussehen;
 * deshalb auch 14 px statt der 12 px der grauen Feldhinweise (💎 2026-10-02).
 *
 * Die `id` verdrahtet den Satz per `aria-describedby` mit seinem Feld: ein gesperrtes Feld ohne
 * Begründung liest eine Vorlesehilfe nur als „nicht verfügbar".
 */
export const ModerationsHinweis: React.FC<{ id: string; warnung?: boolean; children: React.ReactNode }> = ({
  id,
  warnung = false,
  children,
}) =>
  warnung ? (
    <p id={id} className="mt-2 rounded border border-warning-200 bg-warning-50 p-3 text-sm text-warning-800">
      {children}
    </p>
  ) : (
    <p id={id} className="mt-1 text-xs text-secondary-500">
      {children}
    </p>
  );
